import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { Planogram } from "./model/planogram";
import { Constants } from '../../../../app.constant';
import { PlanogramService } from "../../../cms/components/planogram/services/planogram.service";
import { ErrorComponent } from '../errorComponent/error.component';
import * as _ from 'lodash';
import { Campaign, PlaylistContent } from '../../../cms/components/campaign/models/campaign';
import { CampaignService } from '../../../cms/components/campaign/services/campaign.service';
import { MediaLibraryServices } from '../../../cms/components/media-library/services/mediaLibraryServices';
import { CampaignPreviewShared } from '../campaign-preview/campaign-preview.component';
@Component({
  selector: 'app-planogram-preview',
  templateUrl: './planogram-preview.component.html',
  styleUrls: ['./planogram-preview.component.scss']
})
export class PlanogramPreviewComponent implements OnInit {

  public planogram: Planogram;
  public error: string = '';
  public errorObj: any = [];
  public _isActive: any = [];
  public _isChilds: any = [];
  public showPreview = false;
  public campaignToPreview;
  public campaignString;
  public currentCampaignIndex;
  public showDisclaimer = false;
  public dateFormate = Constants.Var.dateFormate;
  public timestampFormate = Constants.Var.timestampFormate;
  @ViewChild(CampaignPreviewShared) campaignPreview: CampaignPreviewShared;

  constructor(
    private _err: ErrorComponent,
    private _router: Router,
    private _route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private planogramService: PlanogramService,
    private toasterService: ToasterService,
    private errorComponent: ErrorComponent,
    private campaignService: CampaignService,
    private mediaService: MediaLibraryServices
  ) { }

  ngOnInit() { }

  public toggle = function (id: number): void {
    this._isActive[id] = !this._isActive[id];
  }

  public toggleChild = function (id: number): void {
    this._isChilds[id] = !this._isChilds[id];
  }

  public closeModal() {
    this.activeModal.close();
  }

  public previewCampaign(campaign, index) {
    if (this.campaignPreview)
      this.campaignPreview.resetPlaybackSlider(0);

    this.showPreview = true;
    this.showDisclaimer = false;
    this.campaignService.getCampaignFullDetails(campaign.layoutId, this.mediaService)
      .subscribe((campaign: Campaign) => {
        if (campaign) {
          this.campaignToPreview = campaign;
          this.currentCampaignIndex = index;
          _.forEach(campaign.regions, (region) => {
            _.forEach(region['globalRegionContentPlaylistContents'], (content) => {
              if (content.contentType == "URL") {
                this.showDisclaimer = true;
              }
            })
          });
        }
        else {
          // show error.
        }
      },
      err => {
        this.errorObj = err.error;
      });
  }

  public previewCampaignString(campaignString: any) {
    this.planogramService.getCampaignString(campaignString.layoutStringId)
      .subscribe((res) => {
        if (res) {
          this.campaignString = res.result;
          if (this.campaignString && this.campaignString.layouts && this.campaignString.layouts.length) {
            this.previewCampaign(this.campaignString.layouts[0], 0);
          }
        }
      },
      err => {
        this.errorObj = err.error;
      });
  }

  public replayCampaignPreview() {
    this.campaignPreview.replay(this.campaignToPreview.audios, 0);
  }

  public goBack() {
    this.showPreview = false;
    this.campaignString = null;
    this.campaignToPreview = null;
  }

  public getScheduleDays(arr){
    let string='';
    let st=_.startCase(_.toLower(arr))
    let st1=st.split(" ");
    _.forEach(st1,(val,index)=>{
      if(index == (arr.length -2))
        string=string+val+' & '
      else
        if(index == (arr.length -1))
          string=string+val
        else
          string=string+val+','
    })
    return string;
  }

  displayString(key){
    return Constants.DisplayTranslatedString(key);
  }

  public nthWeek(val){
    if(val == 1)
      return val+'st'
    else if(val == 2)
      return val+'nd'
    else if(val == 3)
      return val+'rd'
    else
      return val+'th'
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/shared/components/planogram-preview/planogram-preview.component.ts